<template>
  <div class="fill-height" style="position: relative">
    <v-progress-linear
      v-if="isLoading"
      :indeterminate="true"
      class="ma-0"
      style="position: absolute;"
    ></v-progress-linear>
    <template v-if="false === hasPositions">
      <div class="container text-center fill-height d-flex justify-center align-center no-map">
        <div>
          <img
            src="@/assets/no-map.png"
            alt="No positions"
            :class="{ 'empty-img-small': $vuetify.breakpoint.smAndDown }"
          />
          <h1 class="headline primary--text">No vessel positions :(</h1>
          <p class="subheading">
            <template class="hidden-sm-and-down">
              You need USAIL Telemetry in order to see your boats in the map.
            </template>
            You can hire USAIL Telemetry <a href="#">here</a>.
          </p>
          <small class="hidden-sm-and-down">
            If you already have USAIL Telemetry and can not see your vessels,
            <a href="#">contact us here</a>.
          </small>
        </div>
      </div>
    </template>
    <div class="fill-height" :class="{ collapse: !hasPositions }" style="position: relative;">
      <WindyMap
        ref="windyMap"
        :hidden="'windy' !== mapProvider || false === hasPositions"
        :markers="windyMarkers"
        :on-marker-click="clickVessel"
        :positions-geo-json="positionsGeoJson"
        :vessel="vessel"
      ></WindyMap>
      <GmapsMap
        :hidden="'google' !== mapProvider || false === hasPositions"
        :markers="gMapsMarkers"
        :on-marker-click="clickVessel"
        :positions-geo-json="positionsGeoJson"
        :vessel="vessel"
        :fetch-geo-json="fetchGeoJson"
      ></GmapsMap>

      <v-speed-dial v-model="mapFab" style="position: absolute; right: 16px; bottom: 16px;">
        <template v-slot:activator>
          <v-btn color="white" fab>
            <v-icon v-if="mapFab">mdi-close</v-icon>
            <v-icon v-else>mdi-map</v-icon>
          </v-btn>
        </template>
        <v-btn fab small color="#A00001" @click="$store.commit('mapSetMapProvider', 'windy')">
          <img style="width: 24px" src="@/assets/img/Windy_logo.svg" />
        </v-btn>
        <v-btn fab small color="blue" dark @click="$store.commit('mapSetMapProvider', 'google')">
          <v-icon>mdi-google-maps</v-icon>
        </v-btn>
      </v-speed-dial>
    </div>

    <v-snackbar v-model="snackbar">
      {{ $t('error.loading_resource') }}
      <v-btn text color="warning" @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import fetch from '@/utils/fetch'
import WindyMap from '@/components/WindyMap'
import GmapsMap from '@/components/GmapsMap'

export default {
  name: 'Map',

  components: {
    GmapsMap,
    WindyMap
  },

  filters: {
    floatPadStart: function(value, maxLength, fillString) {
      if (!value) return ''
      const strVal = Math.abs(value).toString()
      const splitVal = strVal.split('.')

      splitVal[0] = splitVal[0].padStart(maxLength, fillString)

      let newVal = splitVal.join('.')

      if (value < 0) {
        newVal = '-' + newVal
      }

      return newVal
    },

    toCompass: function(degrees) {
      return ['N', 'NNE', 'NE', 'ENE', 'E', 'ESE', 'SE', 'SSE', 'S', 'SSW', 'SW', 'WSW', 'W', 'WNW', 'NW', 'NNW', 'N'][
        Math.round(degrees / 11.25 / 2)
      ]
    }
  },

  data: function() {
    return {
      snackbar: false,
      positionsGeoJson: null,
      getterIntervals: [],
      mapRefreshInterval: 60000,
      vessels: null,
      isLoadingVessels: false,
      vessel: null,
      mapFab: false
    }
  },

  computed: {
    hasPositions: function() {
      if (!this.vessels) {
        return null
      }

      let hasLatestPosition = false

      this.vessels.forEach(vessel => {
        if (vessel.latestPosition) {
          hasLatestPosition = true
        }
      })

      return hasLatestPosition
    },

    mapProvider: function() {
      return this.$store.state.map.mapProvider
    },

    showPaths: {
      get() {
        return this.$store.state.map.showPaths
      },
      set(val) {
        this.$store.commit('mapSetShowPaths', val)
      }
    },

    isLoadingPath: function() {
      return this.$store.state.map.isLoadingPath
    },

    isLoadingVessel: function() {
      return this.$store.state.map.isLoadingVessel
    },

    marginTop: function() {
      if (this.$vuetify.breakpoint.xsOnly) {
        return -56
      }

      if (this.$vuetify.breakpoint.smAndDown) {
        return -48
      }

      return -64
    },

    isLoading: function() {
      return this.isLoadingVessels || this.isLoadingVessel || this.isLoadingPath
    },

    gMapsMarkers: function() {
      if (this.vessels && 'google' === this.mapProvider) {
        let markers = []
        this.vessels.forEach(function(vessel) {
          if (vessel.latestPosition) {
            let marker = {
              vessel: vessel,
              position: {
                lat: vessel.latestPosition.latitude,
                lng: vessel.latestPosition.longitude
              },
              infoText: vessel.name,
              options: {
                title: vessel.name
              }
            }
            markers.push(marker)
          }
        })
        return markers
      }

      return []
    },

    windyMarkers: function() {
      if (this.vessels && 'windy' === this.mapProvider) {
        let markers = []
        this.vessels.forEach(function(vessel) {
          if (vessel.latestPosition) {
            let marker = {
              vessel: vessel,
              position: {
                lat: vessel.latestPosition.latitude,
                lng: vessel.latestPosition.longitude
              },
              infoText: vessel.name,
              options: {
                title: vessel.name
              }
            }
            markers.push(marker)
          }
        })
        return markers
      }

      return []
    }
  },

  watch: {
    $route() {
      this.$store.commit('mapSetShowPaths', false)
      this.$store.commit('mapSetIsLoadingPaths', false)
      this.positionsGeoJson = null
      this.scheduleGetters()
    },

    showPaths: function(showPaths) {
      if (true === showPaths) {
        this.fetchGeoJson()
      } else {
        this.positionsGeoJson = null
      }
    },

    vessel: function(newVessel, oldVessel) {
      if (newVessel) {
        this.fetchVessels(newVessel.organization['@id'])
      }

      if (newVessel !== oldVessel) {
        if (this.showPaths) {
          this.fetchGeoJson()
        } else {
          this.positionsGeoJson = null
        }
      }
    },

    mapProvider: function() {
      this.showPaths = false
    }
  },

  mounted() {
    // this.vesselsReset()
    this.scheduleGetters()
  },

  destroyed() {
    this.vessels = null
    this.vessel = null
    this.positionsGeoJson = null
    if (this.getterIntervals.length > 0) {
      this.getterIntervals.forEach(interval => {
        clearInterval(interval)
      })
      this.getterIntervals = []
    }
    //this.vesselReset()
    //this.vesselsReset()
  },

  methods: {
    fetchVessels(organizationId) {
      this.isLoadingVessels = true

      let url = '/vessels'

      if (organizationId) {
        url = '/vessels?organization=' + organizationId + '&pagination=false'
      }

      url += '&archived=false'

      fetch(url)
        .then(response => {
          this.isLoadingVessels = false
          return response.json()
        })
        .then(data => {
          this.vessels = data['hydra:member']
        })
        .catch(() => {
          this.isLoadingVessels = false
          this.snackbar = true
        })
    },

    fetchVessel(vesselId) {
      this.$store.commit('mapSetIsLoadingVessel', true)

      fetch(vesselId)
        .then(response => {
          this.$store.commit('mapSetIsLoadingVessel', false)
          return response.json()
        })
        .then(data => {
          this.vessel = data
        })
        .catch(() => {
          this.$store.commit('mapSetIsLoadingVessel', false)
          this.snackbar = true
        })
    },

    scheduleGetters() {
      if (this.getterIntervals.length > 0) {
        this.getterIntervals.forEach(interval => {
          clearInterval(interval)
        })
        this.getterIntervals = []
      }
      if ('VesselShowMap' === this.$route.name) {
        this.fetchVessel('/vessels/' + this.$route.params.id + '?groups[]=fleet-commander-show')
        this.getterIntervals.push(
          setInterval(() => {
            this.fetchVessel('/vessels/' + this.$route.params.id + '?groups[]=fleet-commander-show')
          }, this.mapRefreshInterval)
        )
      }

      if ('OrganizationShowMap' === this.$route.name) {
        this.vessel = null
        this.fetchVessels('/vessels/' + this.$route.params.id)
        this.getterIntervals.push(
          setInterval(() => {
            this.fetchVessels('/vessels/' + this.$route.params.id)
          }, this.mapRefreshInterval)
        )
      }

      if ('OrganizationListMap' === this.$route.name) {
        this.vessel = null
        this.fetchVessels()
        this.getterIntervals.push(
          setInterval(() => {
            this.fetchVessels()
          }, this.mapRefreshInterval)
        )
      }

      this.getterIntervals.push(
        setInterval(() => {
          if (true === this.showPaths) {
            this.fetchGeoJson()
          }
        }, this.mapRefreshInterval)
      )
    },

    fetchGeoJson() {
      this.$store.commit('mapSetIsLoadingPaths', true)

      const d = new Date()
      d.setDate(d.getDate() - 7)
      const dIso = d.toISOString()
      const url =
        '/vessel_positions.geojson?vessel=' + this.vessel['@id'] + '&observedAt[after]=' + dIso + '&pagination=false'
      const headers = new Headers({
        Accept: 'application/geo+json',
        'Content-Type': 'application/json'
      })

      fetch(url, {
        headers: headers
      })
        .then(response => {
          this.$store.commit('mapSetIsLoadingPaths', false)
          return response.json()
        })
        .then(data => {
          this.positionsGeoJson = data
        })
        .catch(() => {
          this.$store.commit('mapSetIsLoadingPaths', false)
          this.snackbar = true
        })
    },

    clickVessel(marker) {
      //this.getVessel(marker.vessel['@id'])
      this.$router.push({
        name: 'VesselShowMap',
        params: { id: this.$iriToId(marker.vessel['@id']) }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.hidden {
  display: none;
}

.no-map {
  background: url('../assets/no-map-bg.svg') center;
  background-size: cover;
}

.empty-img-small {
  height: 80px;
}

@keyframes slideInFromLeft {
  0% {
    width: 0;
    min-width: 0;
    opacity: 0;
  }
  100% {
    width: 350px;
    min-width: 350px;
    opacity: 100;
  }
}

.collapse {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -999;
  width: 100%;
  height: 100%;
}
</style>

<style lang="scss">
.map-custom-controls {
  .v-toolbar__content {
    padding: 0 !important;
  }
}
</style>
